<div class="address-container">
    <div *ngIf="addressFound$.value" class="map">
        <button class="expand-map-btn" (click)="openMap()" aria-label="click to expand map">
            <img src="assets/images/expand.svg" alt="expand icon" />
        </button>
        <img
            src="https://maps.googleapis.com/maps/api/staticmap?zoom=14&size=320x170&maptype=roadmap&markers=color:red%7C%7C{{
                getEncodedAddressString()
            }}&key={{ API_KEY }}"
            alt="Address Map"
        />
    </div>
    <address-input
        [builders$]="builders$"
        [communities$]="communities$"
        [buildingTypes$]="buildingTypes$"
        [address$]="address$"
        [includeLookup]="true"
        [addressFound$]="addressFound$"
        [addressFoundFromGoogle$]="addressFoundFromGoogle$"
        [isReadOnly]="isReadOnly"
    ></address-input>
</div>
